import { computed, signal, Signal } from '@angular/core';
import { GenEiaRegion } from '../../../../generated/serverModels/GenEiaRegion';
import { Territory } from '../../../classes/territory';

export interface DropdownItem {
  name: string;
  isSelected: Signal<boolean>;
}

export class RegionDropdownItem extends GenEiaRegion {
  constructor(public region: GenEiaRegion) {
    super(region);
  }

  public readonly isExpanded = signal(false);
  public readonly isSelected = computed(() => this.children.every(child => child.isSelected()));
  public readonly isPartial = computed(() => !this.isSelected() && this.children.some(child => child.isSelected()));

  public readonly children: StateDropdownItem[] = this.states.map(state => new StateDropdownItem(state));
}

export class StateDropdownItem extends Territory {
  constructor(public state: Territory) {
    super(state);
  }
  public readonly isSelected = signal(false);
}

